<template>
	<a-modal width="55%" title="详情" :visible="visible" centered :destroy-on-close="true" :mask-closable="false"
		:confirm-loading="confirmLoading" :footer="null" @ok="onSubmit" @cancel="onClose">
		<a-descriptions :column="2">
			<a-descriptions-item label="职位名称">
				<dict-render :dict-obj="dictObjs['hope_job']" v-if="form.jobTitle" :text="form.jobTitle"></dict-render>
			</a-descriptions-item>
			<a-descriptions-item label="行业类型">
				<dict-render :dict-obj="dictObjs['research_field']" v-if="form.industry" :text="form.industry"></dict-render>
			</a-descriptions-item>
			<a-descriptions-item label="工作性质">
				<dict-render :dict-obj="dictObjs['work_type']" v-if="form.natureWork" :text="form.natureWork"></dict-render>
			</a-descriptions-item>
			<a-descriptions-item label="学历">
				<dict-render :dict-obj="dictObjs['education_background']" v-if="form.educationBackground"
					:text="form.educationBackground"></dict-render>
			</a-descriptions-item>
			<a-descriptions-item label="工作城市">{{ form.provject }}</a-descriptions-item>
			<a-descriptions-item label="详细地址">{{ form.fullAddress }}</a-descriptions-item>
			<a-descriptions-item label="薪资">
				<dict-render :dict-obj="dictObjs['salary']" v-if="form.salary" :text="form.salary"></dict-render>
			</a-descriptions-item>
			<a-descriptions-item label="工作经验">
				<dict-render :dict-obj="dictObjs['work_experience']" v-if="form.workExperience"
					:text="form.workExperience"></dict-render>
			</a-descriptions-item>
			<a-descriptions-item label="福利待遇">
				<dict-render :multiple="true" :dict-obj="dictObjs['fringe_benefits']" v-if="form.welfareTreatment"
					:text="form.welfareTreatment"></dict-render>
			</a-descriptions-item>
			<a-descriptions-item label="联系人姓名">{{ form.contactName }}</a-descriptions-item>
			<a-descriptions-item label="联系人电话">{{ form.contactNumber }}</a-descriptions-item>
			<a-descriptions-item label="招聘人数">{{ form.numberRecruits }}</a-descriptions-item>
			<a-descriptions-item label="期望入职时间" :span="2">{{ form.expectedTimeEntry && form.expectedTimeEntry ?
				form.expectedTimeEntry.split(' ')[0] : ''
			}}</a-descriptions-item>
			<a-descriptions-item label="岗位职责" :span="2">{{ form.jobResponsibility }}</a-descriptions-item>
			<a-descriptions-item label="任职要求" :span="2">{{ form.jobRequirements }}</a-descriptions-item>
		</a-descriptions>
	</a-modal>
</template>
<script>
import { formMixin, dictMixin } from "@/mixins";
import DictRender from "@/components/other/DictRender";
export default {
	name: "DetailModal",
	components: {
		DictRender
	},

	mixins: [formMixin, dictMixin],
	data() {
		return {
			dictNames: 'research_field,education_background,salary,work_experience,work_type,fringe_benefits,hope_job',
			form: {
				parentId: null,
			},
		}
	},
}
</script>
<style scoped lang="less"></style>
